import { CustomCategory } from "@/components/category";
import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import Link from "next/link";

type SmallProps = {
  play: Content.Play;
};

const Small = (props: SmallProps) => {
  const title = props.play.fields.teaserTitle || props.play.fields.title;
  const playShow = props.play.fields["play-show"];

  return (
    <Link
      href={`/play/${props.play.fields.slug}`}
      className="group block bg-black-400 p-4"
    >
      {playShow && (
        <CustomCategory name={playShow.fields.title} inverted color="Play" />
      )}

      {title && <TeaserHeading text={title} className="text-static-white" />}
    </Link>
  );
};

export default Small;
